<div class="col-md-12">
  <div class="row mb-3">
    <div class="col-md-8">
      <span class="badge badge-primary">{{ penalties?.length || 0 }} pénalité(s)</span>
    </div>
    <div class="col-md-4 text-right">
      <button class="btn btn-primary btn-sm" (click)="addPenalty()">
        <i class="feather icon-plus"></i> Ajouter
      </button>
    </div>
  </div>
  <div class="table-responsive">
    <table datatable [dtOptions]="dtOptions" class="table table-sm table-striped table-bordered nowrap table-hover">
      <thead class="thead-light">
        <tr>
          <th>Référence</th>
          <th>Copropriétaire</th>
          <th>Type</th>
          <th>Montant impayé</th>
          <th>Montant pénalité</th>
          <th>Jours retard</th>
          <th>Statut</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of penalties">
          <td>{{ item?.reference }}</td>
          <td>{{ item?.ownerCo?.nomComplet }}</td>
          <td>
            <span class="badge badge-info">{{ item?.typePenalite }}</span>
          </td>
          <td class="text-right">{{ item?.montantImpayeBase | number:'1.0-0' }} FCFA</td>
          <td class="text-right text-danger">{{ item?.montantPenalite | number:'1.0-0' }} FCFA</td>
          <td class="text-right">{{ item?.joursRetard }}</td>
          <td>
            <span class="badge" [ngClass]="{
              'badge-warning': item?.statut === 'EN_COURS',
              'badge-success': item?.statut === 'PAYE',
              'badge-secondary': item?.statut === 'ANNULE'
            }">{{ item?.statut }}</span>
          </td>
          <td class="text-center">
            <button class="btn btn-icon btn-outline-primary btn-sm mr-1" title="Modifier" (click)="editPenalty(item)">
              <i class="feather icon-edit-2"></i>
            </button>
            <button class="btn btn-icon btn-outline-danger btn-sm" title="Supprimer" (click)="deletePenalty(item)">
              <i class="feather icon-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
